<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <!--创建订单-->
          <div class="common-new-title mode2" v-if="!searchLock">
            <span>芥末订单列表</span>
            <router-link
              v-if="canWriteTeacher"
              class="button-search icon-index-1 jm-fr"
              target="_blank"
              :to="{ name: 'jmOrderForm2022', params: { id: searchData.crm_id, orderId: 0 } }">
              <el-button
                type="primary"
                size="medium">创建订单</el-button>
            </router-link>
          </div>
          <!--列表部分 start -->
          <div class="searchList" v-if="searchLock">
            <div class="box-content">
              <label class="form-tit">学生姓名</label>
              <el-input v-model="searchData.custom_name" class="jm-input280"></el-input>
            </div>
            <div class="box-content">
              <label class="form-tit">电话</label>
              <el-input v-model="searchData.crm_tel" class="jm-input280"></el-input>
            </div>
            <div class="box-content">
              <label class="form-tit">客户ID</label>
              <el-input v-model="searchData.crm_id" class="jm-input280"></el-input>
            </div>
            <div class="box-content">
              <label class="form-tit">订单编号</label>
              <el-input v-model="searchData.order_no" class="jm-input280"></el-input>
            </div>
            <div class="box-content">
              <label class="form-tit">订单状态</label>
              <jm-dict-select
                class="jm-input280"
                clearable
                v-model="searchData.order_status"
                dict="jiemo.order_status2022"
                value-type="string"/>
            </div>
            <div class="box-content">
              <label class="form-tit">发起人</label>
              <el-select
                v-model="searchData.create_uid"
                filterable
                class="jm-input280"
                clearable
                multiple
                placeholder="请选择">
                <el-option-group
                  v-for="(group, k) in pageDs.create_list"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    v-show="item.userid > 0"
                    :key="item.userid"
                    :label="item['username']"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">应付金额</label>
              <el-input
                v-model="searchData.need_fee.min"
                class="jm-input135"/>
              <el-input
                v-model="searchData.need_fee.max"
                class="jm-input135"/>
            </div>
            <div class="box-content">
              <label class="form-tit">已付金额</label>
              <el-input
                v-model="searchData.paid_fee.min"
                class="jm-input135"/>
              <el-input
                v-model="searchData.paid_fee.max"
                class="jm-input135"/>
            </div>
            <div class="box-content">
              <label class="form-tit">创建时间</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.create_time"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">缴费截止日期</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.last_payment_date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="search-btn" v-if="searchLock">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="search()">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
          </div>

          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
            ref="tableList"
          >
            <el-table-column
              slot="order_no"
              label="订单编号">
              <template slot-scope="scope">
                <el-popover
                  v-if="scope.row.commission_status < 2"
                  placement="top"
                  width="200"
                  trigger="hover"
                  content="当前订单需要外联确认">
                  <i slot="reference" class="el-icon-info" style="color:#F75694"></i>
                </el-popover>
                {{ scope.row.order_no }}
              </template>
            </el-table-column>
            <el-table-column
              slot="order_title"
              label="订单名称">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.order_title }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.order_title }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="apply_school_list"
              label="所申学校">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ schoolFormat(scope.row.apply_school_list) }}
                  <span slot="reference" class="white-nowrap">{{ schoolFormat(scope.row.apply_school_list) }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="order_memo"
              label="订单备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.order_memo }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.order_memo }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="140"
              label="操作">
              <template slot-scope="scope">
                <div>
                  <Copy v-if="canWriteTeacher" :content="scope.row.order_url" @copyCallback="$message.success('复制成功')">
                    <el-button
                      v-show="!(scope.row.commission_status < 2)"
                      type="success"
                      size="small">订单链接</el-button>
                  </Copy>
                  <router-link
                    v-if="canWriteTeacher || readOnlyManager || $hasPermission(173)"
                    target="_blank"
                    :to="{ name: 'jmOrderDetail2022', params: { orderId: scope.row.id, id: scope.row.crm_id }}">
                    <el-button
                      type="primary"
                      size="small">{{ canWriteTeacher ? '报账/缴费' : '查看订单' }}</el-button>
                  </router-link>
                  <router-link
                    v-if="(canWriteTeacher || $hasPermission(173)) && !scope.row.payment_count"
                    target="_blank"
                    :to="{ name: 'jmOrderForm2022', params: { orderId: scope.row.id, id: scope.row.crm_id }}">
                    <el-button
                      type="primary"
                      size="small">编辑订单</el-button>
                  </router-link>
                  <el-button
                    v-if="canWriteTeacher && !scope.row.payment_count"
                    @click="deleteOrder(scope.row)"
                    type="danger">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { deepClone, formatSelectGroupData } from '@/utils/utils.js';

const defaultSearchData = {
  crm_id: '',
  custom_name: '',
  crm_tel: '',
  order_no: '',
  order_status: '',
  create_uid: [],
  need_fee: { min: '', max: '' },
  paid_fee: { min: '', max: '' },
  create_time: '',
  last_payment_date: ''
};

export default {
  data() {
    return {
      loading: false,
      searchLock: false,
      getListurl: '/index/jm.order2022/userList', // 表格数据源
      searchData: deepClone(defaultSearchData),
      pageDs: {}
    };
  },
  computed: {
    // 只读类主管
    readOnlyManager () {
      return this.$hasPermission([
        33, // 日本主管
        121, // 英美主管
        148, // 欧亚主管(日韩)
        22, // 韩国主管
        96, // 英美文书主管
        122, // 英美咨询主管
        101, // 日本咨询主管
        39, // 前程日本主管
        51, // 前程日本咨询主管
      ], true);
    },
    // 可写类老师
    canWriteTeacher () {
      return this.$hasPermission([
        20, // 日本咨询
        19, // 日本文案
        141, // 日本规划
        54, // 韩国亚欧咨询
        124, // 英美咨询
        166, // 亚欧英美文书
        125, // 英美文案
        135, // 韩国文案
      ]);
    }
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.searchData = deepClone(defaultSearchData);
      this.$store.commit('updateRefresh', true);
    },
    search(params = {}) {
      this.searchData = Object.assign({}, this.searchData, params);
      this.$store.commit('updateRefresh', true);
    },
    deleteOrder(row) {
      this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/jm.order2022/delete',
          data: {
            id: row.id
          }
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.search();
        });
      });
    },
    schoolFormat(val) {
      let arr = [];
      val.forEach((item) => {
        arr.push(item.sh_name_cn);
      });
      return arr.toString();
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.c === 'student') {
      next((vm) => {
        vm.searchData.crm_id = to.params.id;
        vm.getListurl = '/index/jm.order2022/userList';
      });
    } else {
      next((vm) => {
        vm.searchData.crm_id = '';
        vm.getListurl = '/index/jm.order2022/list';
        vm.searchLock = true;
      });
    }
    return true;
  },
  mounted() {
    if (this.$route.params.id) {
      this.$http._post({
        url: '/index/jm.order2022/searchDs',
        data: {
          crm_id: this.$route.params.id
        }
      }).then(({ data }) => {
        this.pageDs = data;
        this.pageDs.create_list = formatSelectGroupData(data.create_list);
      }).catch((res) => {
        console.log(res);
      });
    } else {
      this.$http._post({
        url: '/index/jm.order2022/SearchDs'
      }).then(({ data }) => {
        this.pageDs = data;
        this.pageDs.create_list = formatSelectGroupData(data.create_list);
      }).catch((res) => {
        console.log(res);
      });
    }
  }
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
</style>
